module.exports = __webpack_public_path__ + "img/g.f8d17473.png";